import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { App } from "./App.js";
import "./styles/cyberpunk.css";
import { Dashboard } from "./routes/Dashboard.js";
import { NewJob } from "./routes/NewJob.js";
import { JobProgress } from "./routes/JobProgress.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "new-job", element: <NewJob /> },
      { path: "job/:token", element: <JobProgress /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
